var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewmsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(379 -4798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1589",
    "data-name": "Rectangle 1589",
    width: 23,
    height: 23,
    transform: "translate(-379 4798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    "data-name": "Group 2220",
    transform: "translate(-379 4679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M137,125H119.937l8.529,6.689Z",
    transform: "translate(-114.598 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M56.634,163.163l-8.924-7v2.245H44.9v1.336h2.81v1.465H45.45v1.336h2.259v1.465H44.758v1.336h2.951v1.13H65.558V156.164Z",
    transform: "translate(-42.765 -29.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M0,332.414H1.328v1.328H0Z",
    transform: "translate(0 -198.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M14.918,269.582h1.328v1.328H14.918Z",
    transform: "translate(-14.254 -138.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M3.582,206.754H4.91v1.328H3.582Z",
    transform: "translate(-3.423 -78.115)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmsg);
export default __webpack_public_path__ + "static/media/newmsg.4a128212c7d6f8dc26b872c605c2ef36.svg";
export { ForwardRef as ReactComponent };